import { MARK_AS_COMPLETE_JOB } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case MARK_AS_COMPLETE_JOB.LOAD:
      return {
        ...state,
        loading: true,
      };
    case MARK_AS_COMPLETE_JOB.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case MARK_AS_COMPLETE_JOB.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
